// Liste des technos affichées dans le carrousel de l'accueil (Brand) et dans la
// grille de /about (Competences). Une seule source pour les deux, sinon l'une
// des deux finit par dériver.
//
// Deux origines d'icônes :
//   - `fa` : icône Font Awesome Brands, rendue via <i className="fab fa-…">.
//   - `svg`: icône Simple Icons (cdn.simpleicons.org) téléchargée dans
//     img/brands/. Font Awesome ne couvre pas TypeScript, Next.js, PostgreSQL,
//     tRPC, Supabase ni MongoDB.
//
// Le SVG est appliqué en masque CSS et coloré par `currentColor` (cf. la classe
// .brand-icon) : il suit donc exactement le même comportement que les icônes
// Font Awesome, qui restent neutres et prennent leur couleur de marque au
// survol (voir $competences dans styles/settings/_settings.scss).

import typescript from "../img/brands/typescript.svg";
import nextdotjs from "../img/brands/nextdotjs.svg";
import postgresql from "../img/brands/postgresql.svg";
import trpc from "../img/brands/trpc.svg";
import supabase from "../img/brands/supabase.svg";
import mongodb from "../img/brands/mongodb.svg";

const competences = [
	// Stack actuelle en premier
	{ _class: "typescript", color: "#3178C6", svg: typescript },
	{ _class: "react", color: "#61dafb" },
	{ _class: "nextdotjs", color: "#000000", svg: nextdotjs },
	{ _class: "node", color: "#43853d" },
	{ _class: "trpc", color: "#2596BE", svg: trpc },
	{ _class: "postgresql", color: "#4169E1", svg: postgresql },
	{ _class: "supabase", color: "#3FCF8E", svg: supabase },
	{ _class: "mongodb", color: "#47A248", svg: mongodb },

	// Le reste du parcours
	{ _class: "js-square", color: "#f7df1e" },
	{ _class: "html5", color: "#f16529" },
	{ _class: "css3-alt", color: "#2965f1" },
	{ _class: "sass", color: "#CC6699" },
	{ _class: "bootstrap", color: "#563e7c" },
	{ _class: "php", color: "#8892BF" },
	{ _class: "laravel", color: "#ff2d20" },
	{ _class: "symfony", color: "#000000" },
	{ _class: "java", color: "#ea2d2e" },
	{ _class: "python", color: "#ffcf3f" },
	{ _class: "android", color: "#3ddb84" },
	{ _class: "docker", color: "#319AEA" },
	{ _class: "git", color: "#f05133" },
	{ _class: "linux", color: "#f79202" },
];

export default competences;
